import {blockUi, unblockUi} from "@/modules/elements-blockui";
import {getActiveFilterUrl} from "@/helpers/filter/filter-helper";
import {getFilterDomainList} from "@/http/services/http-services-filter";
import $ from "jquery";
import {getDataTableFilterSettings, updateFilterBadge} from "@/helpers/filter/filter-settings-helper";

export function setUpListObserver(element, formAttribute, selectize) {
    const select = element.querySelector('select')

    let defaultPlaceHolder = 'Kies waarde...'
    let closeOnSelect = true
    if(formAttribute.AttributeTypeID === 1023) {
        defaultPlaceHolder = 'Kies een of meerdere waardes...'
        closeOnSelect = false
    }

    select.addEventListener('change', element => {
        window.filterData.columns.find(column => {
            if(column.data === formAttribute.attribute.Attribute) {
                column.search.value = element.target.value
            }
        })
    })

    const observer = new IntersectionObserver((entries, observer) => {

        entries.forEach(entry => {
            if(entry.intersectionRatio > 0) {

                window.filterData = getDataTableFilterSettings(window.filterData, 'unique')

                blockUi(element, 0.5)
                const url = getActiveFilterUrl('unique')
                const data = window.filterData
                data.column = formAttribute.ID

                let tempValue = ''
                data.columns.find(column => {
                    if(column.data === formAttribute.attribute.Attribute) {
                        tempValue = column.search.value
                        column.search.value = ''
                    }
                })

                getFilterDomainList(url,  data).then((response) => {
                    return response.json()
                }).then((result) => {

                    data.columns.find(column => {
                        if(column.data === formAttribute.attribute.Attribute) {
                            column.search.value = tempValue
                        }
                    })


                    select.innerHTML = ''

                    if(!selectize) {
                        const option = document.createElement("option");

                        option.text = defaultPlaceHolder
                        if (formAttribute.Placeholder) {
                            option.text = formAttribute.Placeholder
                        }

                        option.value = ''
                        select.add(option)
                    }

                    result.features.map(feature => {
                        const property = feature.properties

                        if(property.name === null) {
                            return
                        }

                        const option = document.createElement("option");
                        option.text = property.name
                        if(property.value && String(property.value).includes(';')) {
                            option.text = property.name
                        } else {
                            option.value = property.value
                        }

                        select.add(option)
                    })

                    if(formAttribute.DefaultValue) {
                        select.value = formAttribute.DefaultValue
                        updateFilterBadge(element, select.value)
                    }

                    const value = getColumnValue(formAttribute)
                    if(value) {
                       select.value = value
                       updateFilterBadge(element, select.value)
                    }

                    if(selectize) {
                        let placeholder = defaultPlaceHolder
                        if(formAttribute.Placeholder) {
                            placeholder = formAttribute.Placeholder
                        }

                        $(select).select2({
                            dropdownAutoWidth: true,
                            closeOnSelect: closeOnSelect,
                            placeholder: placeholder
                        }).on('change.select2', function (e) {

                            const data = $(select).select2('data')

                            let text = []
                            data.map((item) => {
                                text.push(item.text)
                            })
                            updateFilterBadge(element, text.join(', '))

                            window.filterData.columns.find(column => {
                                if(column.data === formAttribute.attribute.Attribute) {
                                    column.search.value = text.join(';')
                                }
                            })
                        })
                        $(select).val(value.split(';'))
                        $(select).trigger('change');
                        $(select).select2('open')
                    }

                    unblockUi(element)
                })
            }
        });
    });
    observer.observe(element);
}

function getColumnValue(formAttribute) {
    let value = null
    window.filterData.columns.find(column => {
        if(column.data === formAttribute.attribute.Attribute) {
            value = column.search.value
        }
    })
    return value
}
